import { motion } from "motion/react"
import { useState } from "react"
import styled from "styled-components"

import { COLORS } from "#styles/colors"

import Flex from "./Flex"

const SkeletonBar = styled(motion.div)`
  width: 100%;
  height: 16px;
  background: linear-gradient(
    90deg,
    transparent 0%,
    ${COLORS.GRAY1} 1%,
    ${COLORS.GRAY2} 25%,
    ${COLORS.GRAY1} 60%,
    transparent 100%
  );
  border-radius: 4px;
  position: relative;
  overflow: hidden;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 200%;
    background: linear-gradient(
      -55deg,
      transparent 0%,
      transparent 40%,
      ${COLORS.GRAY4} 50%,
      ${COLORS.GRAY4} 60%,
      transparent 80%,
      transparent 100%
    );
    opacity: 0.3;
    transform: translateX(var(--x)) translateY(-50%);
  }
`

const SkeletonBlock = ({
  count = 1,
  gap = 4,
}: {
  count?: number
  gap?: number
}) => {
  const [id] = useState(Date.now())

  return (
    <Flex col gap={gap}>
      {Array.from({ length: count }).map((_, index) => (
        <SkeletonBar
          key={`skeleton-${id}-${index}`}
          animate={{
            "--x": ["-100%", "100%"],
          }}
          transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: "linear",
          }}
        />
      ))}
    </Flex>
  )
}

export default SkeletonBlock
